import { SHOW_VEHICLE_HEADERS } from '../../Library/tableHeaders';
import { AddVehicleToLease, getVehiclesInfo } from '../../APIs';
import { ClientPicker, ReactTable } from '../../Components/Molecules';
import { getFilters } from '../../Library/tableHelpers';
import { useState, useMemo, useEffect, useContext, useRef } from 'react';
import { Breadcrumb, SuccessPopupModal } from '../../Components/Atoms';
import { Button, useToast } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import PATH from '../../Routes/paths';
import './style.css';
import { StoreContext } from '../../Library/contexts';

const LeaseVehicles = () => {
  const { filters, constants } = useContext(StoreContext);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState([]);
  const Navigate = useNavigate();
  const clientName = constants.clientMap?.[filters.client]?.cName || "";
  const Toast = useToast();

  const columns = useMemo(() => {
    const cols = [];
    Object.values(SHOW_VEHICLE_HEADERS).forEach(header => {
        cols.push({
          Header: header.nm,
          accessor: header.key,
          disableSortBy: !header.sorting,
          ...getFilters(header),
          Cell: (row) => row.value,
        });
    });
    return cols;
  }, []);

  const fetchVehicles = () => {
    getVehiclesInfo(null, null, (err, resp) => {
      if (err) console.error("LeaseVehicles : Error while fetching all vehicles", err);
      else {
        setData(resp);
      }
    })
  }

  useEffect(() => {
      fetchVehicles();
  }, []);

  const rowSelectHandler = (allSelected, selectedVehicles) => {
    setSelectedRows(selectedVehicles);
  };

  const leaseVehiclesHandler = () => {
    if (!selectedRows.length || !filters.client)
      return;

    const vehIds = selectedRows.map(row => row.original.idx);

    AddVehicleToLease({ clientId: filters.client, leasedVehicles:vehIds}, (failure, success) => {
      if (failure) {
        const errMsg = JSON.parse(failure).data;
        Toast({ isClosable: true, description: errMsg, position: "top-right", status: "error", variant: "solid" })
      }
      else {
        setIsOpen(true);
      };
    })

  };

  const breadcrumbPaths = [
    { idx: 1, name: "Lease", link: PATH.INVENTORY },
    { idx: 2, name: "Vehicles", link: PATH.LEASED_VEHICLES },
    { idx: 3, name: "Add vehicle from inventory", link: "", isCurrentPage: true },
  ];
  return (
    <div className="panel-main lease-vehicles-main">
      <header className='header'>
        <div>
          <Breadcrumb paths={breadcrumbPaths} />
        </div>
        <ClientPicker />
      </header>

      <div className='lease-vehicles-section'>
        <div className='lease-vehicles-table overflow-table'>
          <ReactTable
            heading={"Vehicles in Inventory"}
            columns={columns}
            data={data}
            showSearch={true}
            showSelection={true}
            showSelectAll={false}
            onRowSelect={rowSelectHandler}
          />
        </div>
        {selectedRows && selectedRows.length ? 
          <Button className='lease-vehicles-btn' onClick={leaseVehiclesHandler} >
            Lease {selectedRows.length} vehicles to {clientName}
          </Button>
          : null
        }
      </div>
      <SuccessPopupModal open={isOpen} modalMsg={"Leased vehicles successfully"} closeBtn={"Okay"} modalSize={"lg"} onModalClose={() => Navigate(PATH.LEASED_VEHICLES)} />
    </div>
  )
}

export default LeaseVehicles;